// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"57":"6fe7517c","111":"475d48a5","743":"360a2e78"}[chunkId] + ".chunk.css";
};